import { render, staticRenderFns } from "./ProductServiceCreate.vue?vue&type=template&id=84d39ec6"
import script from "./ProductServiceCreate.vue?vue&type=script&lang=js"
export * from "./ProductServiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports